import React from "react";
import { useNavigate, Link } from 'react-router-dom';
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import SubMenu from "../Component/SubMenu";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';

import mainBg from "../../assets/img/bg-company-01.jpg";
import comOrgImg from "../../assets/img/company_organization.png";
import comOrgImgM from "../../assets/img/company_organization_m.png";

function ComOverview() {
    // 화면 이동을 위한 네비게이터 설정
	const navigate = useNavigate();

	// 일반 또는 관리자 header 설정
	const { argInfo } = useContext(ArgContext);
	const isAdmin = argInfo?.role === 'admin';

    return ( <>
	<main className="page-wrapper">
		{isAdmin ? <AdminHeader /> : <Header />}
		
      {/* <!-- 메인 미이지 + 슬로건 --> */}
			<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
					<div className="textBox">
						<h2>회사소개</h2>
						<p>위피아는 고객의 가치창조 실현을 위하여 창의적 지식과 경쟁력을 지닌 고객중심 기업입니다.</p>
					</div>

					<SubMenu />
			</section>

			<section className="sub-section container-auto sec-my">
					<h3 className="comOverview-title">Great Think, Great Act!</h3>
					<p className="comOverview-text">
						위피아는 2004년 12월 모바일(Wireless)과 사물인터넷(IoT) 세상의 중심에서 미래가치 창출을 목표로 설립되었습니다.<br />
						 위피아의 핵심역량은 Creative한 기획력과 뛰어난 IT 전문가들 입니다.<br />
					   이를 통해 위피아는 IT서비스 전문기업으로 성장 발전할 수 있도록 최선을 다하겠습니다.
						 </p>
			</section>

			
			<section className="sec-py bg-blue organization-chart">
				<div className="container-auto">
					<img src={comOrgImg} alt="Image"  className="pc-img"/>
					<img src={comOrgImgM} alt="Image"  className="m-img"/>
				</div>
			</section>
			

		</main>
	<Footer />
		
        </>
    )
}

export default ComOverview;